<template>
  <ion-page>
    <ion-header class="ion-no-border">
      <ion-toolbar>
        <ion-buttons slot="start">
          <back-button
            :defaultHref="{ name: 'home' }"
            :icon="require('@lib/assets/icons/icon_zurueck.svg')"
            text=""
          >
          </back-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content ref="content">
      <ion-grid fixed>
        <!-- <erklaerung-arag-zahn /> -->
        <div class="ion-padding">
          <!-- <div
            class="c-header u-bg-orange -contain"
            :style="{
              'background-image':
                'url(' + require('@/assets/img/slider/arag_zahn.svg') + ')',
            }"
          >
            <img
              class="c-header__logo"
              width="40"
              src="@/assets/img/arag_logo.png"
            />
          </div> -->
          <Header
            class="u-bg-green -contain"
            headline="Die ARAG Gesundheitsassistenten unterstützen Sie…"
            :image="require('@/assets/img/home/icon_coaching_herz_iso.svg')"
            :logo="require('@/assets/img/arag_logo.png')"
            logoWidth="40"
            hideButton
          />
          <p class="ion-padding-top ion-hide-lg-up">
            <b>Die ARAG Gesundheitsassistenten unterstützen Sie…</b>
          </p>
          <p>
              vor einem Krankenhausaufenthalt:
              <ul>
                  <li>Kontaktaufnahme und Planung der notwendigen Schritte</li>
                  <li>Suche und Vermittlung von Spezialkliniken</li>
              </ul>
          </p>
          <p>
              während einem Krankenhausaufenthalt:
              <ul>
                  <li>Organisation von Verlegung oder Entlassung in Zusammenarbeit mit dem Krankenhaus</li>
              </ul>
          </p>
          <p>
              bei einer Anschlussheilbehandlung:
              <ul>
                  <li>Suche nach geeigneten Kliniken für die Anschlussheilbehandlung</li>
                  <li>Information und Koordination zu ambulanten Alternativen</li>
              </ul>
          </p>
          <p>
              für eine ambulante (Weiter-)Behandlung:
              <ul>
                  <li>Unterstützung bei der Suche nach Therapeuten oder einer Zweitmeinung</li>
              </ul>
          </p>
          <ion-row class="ion-align-items-center">
            <ion-col>
              <ion-button
                size="small"
                fill="clear"
                class="ion-text-wrap ion-no-padding"
                @click="openKostenerstattungModal"
                >Kostenrückerstattung&nbsp;
                <ion-icon :icon="helpCircle" />
              </ion-button>
            </ion-col>
          </ion-row>
          <div class="c-cta">
            <ion-button class="ion-margin-top" @click="openFormContact"
              >Jetzt Kontakt aufnehmen&nbsp;
              <ion-icon
                :src="require('@lib/assets/icons/roodie-white.svg')"
                slot="end"
              ></ion-icon
            ></ion-button>
          </div>
        </div>
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script>
import { chevronBack, helpCircle } from "ionicons/icons";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonContent,
  IonButton,
  IonIcon,
  IonButtons,
  IonGrid,
  IonRow,
  IonCol,
  modalController,
  IonBackButton
} from "@ionic/vue";
import FormContact from "@/components/FormContact";
import KostenerstattungModal from "@arag/components/KostenerstattungAragKoerperlichModal";
import Header from "@/components/Header";

export default {
  components: {
    IonPage,
    IonHeader,
    IonToolbar,
    IonContent,
    IonButton,
    IonIcon,
    IonButtons,
    IonGrid,
    IonRow,
    IonCol,
    Header,
    IonBackButton
  },
  data() {
    return {};
  },
  setup() {
    return {
      chevronBack,
      helpCircle,
    };
  },
  methods: {
    async openFormContact() {
      const modal = await modalController.create({
        component: FormContact,
        componentProps: {
          routing: "ARAG Case Management",
          reference: "Kontakt aufnehmen",
        },
      });
      return modal.present();
    },
    async openKostenerstattungModal() {
      const modal = await modalController.create({
        component: KostenerstattungModal,
      });
      return modal.present();
    },
  },
};
</script>

<style lang="scss" scoped></style>
